import React, { useEffect, useState } from 'react'
import UploadFile from './components/upload-file'
import FileTable from './components/file-table'
import { GET_FILE_BY_PAGINATION } from 'queries/adminPortal'
import { useLazyQuery } from '@apollo/client'
import { notify } from 'components/toastify'
import { MESSAGES, STATUS } from 'constants/messages'
import { IFile } from '../interface'
import { useSession } from 'helpers/checkSession'

interface Props {
  setSelectTab: (tabIndex: number) => void
  setData: (data: number) => void
}

const File: React.FC<Props> = ({ setSelectTab, setData }) => {
  const [listFile, setListFile] = useState<IFile[]>([])
  const { timeOutSession } = useSession()
  const [
    getFileByPagination,
    {
      loading: getFileByPaginationLoading,
      // fetchMore: fetchMoreForGetFileByPagination,
      // refetch: refetchGetFileByPagination,
    },
  ] = useLazyQuery(GET_FILE_BY_PAGINATION)

  const handleGetData = async (take: number, skip: number) => {
    try {
      const response = await getFileByPagination({
        variables: {
          take,
          skip,
        },
        fetchPolicy: 'network-only',
      })

      if (response.error) {
        if (response.error.message === MESSAGES.ERROR.E_SESSION_TIME_OUT) {
          notify(MESSAGES.WARNING.W_TIMEOUT_SESSION, STATUS.WARNING)
          timeOutSession()
        }
        throw response.error
      }

      if (response?.data?.getFileByPagination) {
        const data = response.data?.getFileByPagination
        setListFile(data)
      }
    } catch (error) {
      notify(MESSAGES.ERROR.E_TRY_AGAIN, STATUS.ERROR)
    }
  }

  useEffect(() => {
    handleGetData(20, 0)
  }, [])

  return (
    <div className="px-20 py-10 md:px-10">
      <UploadFile handleGetData={handleGetData} />
      <FileTable
        listFile={listFile}
        setSelectTab={setSelectTab}
        setData={setData}
        getFileByPagination={getFileByPagination}
        getFileByPaginationLoading={getFileByPaginationLoading}
        handleGetData={handleGetData}
      />
      <hr className="my-10 border-t-neutral-6" />
    </div>
  )
}

export default File
